export default {
	login: {
		token: null,
		expires_in: null,
		loginTime: null
	},
	loading: false,
	unauthorized:false,
	showErrBlock:false,
	sessionExpired:false,
	timeLeft: 90,
  type:null,//1-admin,2-company,3-visitor,4-site admin,5-registrar
  prevType:null,
  // mediaURL:'http://102.133.168.113:8778',//staging

  // mediaURL:'http://134.122.16.97:7779',//our staging

  mediaURL:'https://smartvisitor-api.staging9.com',// 9spl-test-staging
 //  mediaURL:'http://192.168.9.172:8080',// client-test-staging

//  mediaURL:'https://api.smartvisitor.co.za:8778',//client live

  visitorId: null,
  prevPage: '',
  disqualified: '',
  fromPath: '/',
  prevPath: '/',
  addGroups: false,
  successMessage: '',
  alertMessage: '',
  formID: '',
}
